// Copyright (c) Hamilton Manufacturing Corp.
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { isMobile } from './api/utility';
import Icon from './form/Icon';
import { useGlobalState } from './globalState/GlobalStateProvider';

const MenuItemLink = styled(Link)`
    margin: 0.3em;
    color: ${({ current, theme, mobile }) => current ? mobile ? theme.mobile.active : theme.active : mobile ? theme.mobile.text : theme.contrast};
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.2s;
    padding: 0 0.5em;
    &:hover {
        color: ${({ current, theme }) => !current ? theme.highlight : ''};
    }
    ${({ current }) => current ? 'font-weight: bold;' : null}
`
const I = styled(Icon)`
    width: 1.5em;
`
const MenuButton = ({ to, label, ...props }) => {
    const {
        state: {
            // mobileView,
        },
    } = useGlobalState();

    const basePath = process.env.PUBLIC_URL;

    const isCurrent = current => {
        const currentPath = window.location.pathname.replace(basePath, '');
        return currentPath.length === 1 || current.length === 1 ? currentPath === current ? 1 : 0 : pathMatching(currentPath.split('/'), current.split('/')) ? 1 : 0
    };

    const pathMatching = (current, pointer) => {
        for (let i = 0; i < pointer.length; i++) {
            if (pointer[i] !== current[i]) return false;
        }
        return true;
    }

    return (
        <MenuItemLink
            to={to}
            current={isCurrent(to)}
            mobile={isMobile() ? 1 : 0}
            {...props}
        >
            {props.icon ? <I icon={props.icon} /> : null}
            {props.children}
            {label?.toUpperCase()}
            {props.childElement}
        </MenuItemLink>
    );
}

export default MenuButton;